<template>
    <v-container class="v-container">
        <v-row justify="center">
            <v-col  :cols="inputCols">
                <v-text-field
                        label="Преподаватели"
                        :value="stats.teachers"
                        type="number"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col :cols="inputCols">
                <v-text-field
                        label="Занятия"
                        :value="stats.classes"
                        type="number"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col :cols="inputCols">
                <v-text-field
                        label="Студенты"
                        :value="stats.students"
                        type="number"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row >
            <v-col :cols="submitCols" :offset="9 - submitCols">
                <v-btn block>
                    Сохранить
                </v-btn>
           </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {HTTP} from "../../axios";

    export default {
        name: "Stats",
        data(){
            return{
                stats: {
                    classes: 0,
                    teachers: 0,
                    students: 0,

                }
            }
        },
        computed: {
            inputCols () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return 12
                    case 'sm': return 12
                    case 'md': return 12
                    case 'lg': return 6
                    case 'xl': return 6
                }
                return false
            },
            submitCols () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return 12
                    case 'sm': return 12
                    case 'md': return 12
                    case 'lg': return 2
                    case 'xl': return 2
                }
                return false
            },
        },
        methods:{
            update(){
                HTTP
                    .get("stats")
                    .then(r=>{
                        this.date = r.data[0].change_date.replace(/(\d+)-(\d+)-(\d+)/,'$3.$2.$1')
                        this.stats.teachers = r.data.find(x => x.name == "teachers").data
                        this.stats.students = r.data.find(x => x.name == "students").data
                        this.stats.classes = r.data.find(x => x.name == "classes").data
                    })
            }
        },
        mounted() {
            this.update()
        }
    }
</script>

<style scoped>

</style>